// Check if body has is-ire class
export const isIre = document.body.classList.contains("is-ire");

let ireFeedUrl = "";
let accessKey = "";

try {
  const rawIreUrl = (window as any).ire_feed_url as string | undefined;

  if (rawIreUrl) {
    const parsed = new URL(rawIreUrl);
    ireFeedUrl = `${parsed.origin}${parsed.pathname}`;

    const ak = parsed.searchParams.get("access_key");
    if (!ak) {
      throw new Error("access_key missing from window.ire_feed_url");
    }

    accessKey = ak;
  }
} catch (err) {
  console.warn("IRE feed config could not be initialized:", err);
}

export { ireFeedUrl, accessKey };

// Other config values
export const ITEMS_PER_PAGE = 6;
export const agencyId = (window as any).agencyId as string;
